import { paletteTheme } from "@configs/theme/custom/palette";

export const tabTheme = {
  inkBarColor: paletteTheme.colorWhite,
  cardBg: paletteTheme.colorWhite,
  controlHeightLG: 20,
  verticalItemPadding: "0px 0px",
  horizontalItemPadding: "0px 0px",
};
